import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ApiCampaign,
  Campaign,
  SelectionSource,
} from '../../types/campaigns.models';

export const CampaignsActions = createActionGroup({
  source: 'Campaigns',
  events: {
    Load: emptyProps(),
    'Load Success': props<{ campaigns: Campaign[] }>(),
    'Load Failure': props<{ error: unknown }>(),
    Select: props<{ id: string; source: SelectionSource }>(),
    'Clear Selection': emptyProps(),

    // Update campaigns async
    'Realtime Campaign Received': props<{ campaign: ApiCampaign }>(),
  },
});
